import { type BoundaryCreateWMSOptimizedAction } from '~/store/frontendState/mapTools/boundary/boundaryCreateWMSOptimized/boundaryCreateWMSOptimized.action';
import {
  BOUNDARY_CREATE_WMS_OPTIMIZED_ADD_ITEM,
  BOUNDARY_CREATE_WMS_OPTIMIZED_REMOVE_ITEM,
  BOUNDARY_CREATE_WMS_OPTIMIZED_UPDATE_ITEM,
} from './boundaryCreateWMSOptimized.actionTypes';
import { type BoundaryCreateWMSOptimizedState } from './boundaryCreateWMSOptimized.state';

const initialState: BoundaryCreateWMSOptimizedState = {
  pendingItems: [],
};

export const boundaryCreateWMSOptimizedReducer = (state: BoundaryCreateWMSOptimizedState = initialState, action: BoundaryCreateWMSOptimizedAction): BoundaryCreateWMSOptimizedState => {
  switch (action.type) {
    case BOUNDARY_CREATE_WMS_OPTIMIZED_ADD_ITEM: {
      return {
        pendingItems: [
          action.payload.item,
          ...state.pendingItems,
        ],
      };
    }
    case BOUNDARY_CREATE_WMS_OPTIMIZED_UPDATE_ITEM: {
      return {
        pendingItems: state.pendingItems.map(item => {
          if (item.id === action.payload.updatedItem.id) {
            return {
              ...item,
              ...action.payload.updatedItem,
            };
          }

          return item;
        }),
      };
    }

    case BOUNDARY_CREATE_WMS_OPTIMIZED_REMOVE_ITEM: {
      return {
        pendingItems: state.pendingItems.filter(item => item.id !== action.payload.id),
      };
    }

    default:
      return state;
  }
};
